import {
    createItenaryFail, createItenaryPending, createItenarySuccess, getSProductItenaryFail, getSProductItenaryPending, getSProductItenarySuccess,
    modifyItenaryFail, modifyItenaryPending, modifyItenarySuccess, deleteExclusionFail, deleteExclusionPending, deleteExclusionSuccess, deleteInclusionFail,
    deleteInclusionPending, deleteInclusionSuccess
} from "./itenarySlice";
    


    
import { fetchSingleProductItenary, itenaryCreation, itenaryModify, inclusionDelete, exclusionDelete } from "../../../api/userApi";
import Swal from "sweetalert2";

export const newItenaryCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createItenaryPending());
        const result = await itenaryCreation(frmDt);
        console.log(result);
        result.status === "success"
            ? dispatch(createItenarySuccess(result.result1.base_product_id))
            : dispatch(createItenaryFail(result.message));


    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        console.log(error);
        Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
        })

        dispatch(createItenaryFail(err.msg));
    }

}



export const getSingleProductItenary = (id) => async (dispatch) => {

    try {
        //call the api
        dispatch(getSProductItenaryPending());
        const result = await fetchSingleProductItenary(id);

        if (result.itenary) {
            return dispatch(getSProductItenarySuccess(result.itenary));
        }
        dispatch(getSProductItenaryFail("ProductItenary is not found"));


    } catch (error) {
        dispatch(getSProductItenaryFail(error));

    }


}



//seasonal modification code

export const itenaryModification = (frmDt) => async (dispatch) => {

    try {
        dispatch(modifyItenaryPending());
        const result = await itenaryModify(frmDt);
        result.status === "success"
            ? dispatch(modifyItenarySuccess(result.message))
            : dispatch(modifyItenaryFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));

        dispatch(modifyItenaryFail(err.msg));
    }

}


//inclusion delete

export const inclusionDeletion = (frmDt) => async (dispatch) => {

    try {
        dispatch(deleteInclusionPending());
        const result = await inclusionDelete(frmDt);

        result.status === "success"
            ? dispatch(deleteInclusionSuccess("Inclusion deleted"))
            : dispatch(deleteInclusionFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        dispatch(deleteInclusionFail(err.msg));
    }

}



//exclusion delete

export const exclusionDeletion = (frmDt) => async (dispatch) => {

    try {
        dispatch(deleteExclusionPending());
        const result = await exclusionDelete(frmDt);

        result.status === "success"
            ? dispatch(deleteExclusionSuccess("Exclusion deleted"))
            : dispatch(deleteExclusionFail(result.message));

    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        dispatch(deleteExclusionFail(err.msg));
    }

}